import { fetchUser } from "../data/query.js";
import { useMenuAxios } from "../context/axios.js";
import { useQuery } from "@tanstack/react-query";
//#region src/modules/core/hooks/use-user-query.ts
var useUserQuery = () => {
	const { instance } = useMenuAxios();
	return useQuery({
		queryKey: ["user"],
		queryFn: () => fetchUser(instance)
	});
};
//#endregion
export { useUserQuery };
